<template>
<div>
  <Fieldset :legend="toUpperCase(translate('education', 'ucfirst'))"
    class="relative w-full px-5 pb-4 mt-5 uppercase bg-white rounded-lg shadow-md border border-color-iron">
    <Skeleton v-if="isLoading && graduations" height="1.5rem" class="mb-2"></Skeleton>
    <ul v-else-if="!isLoading && graduations.length > 0">
      <li>
        <div v-for="(graduation, index) in graduations" :key="index" class="mb-2.5 mt-5 relative">
          <h1 class="uppercase leading-5 font-semibold text-oxford-blue">
            {{ graduation.degree }}
          </h1>
          <h5 class="text-sm font-medium uppercase">{{ graduation.institution }}</h5>
          <div>
            <span class="text-sm font-medium">{{ dateFormated(graduation.start_date) }} - {{ dateFormated(graduation.end_date) }}</span>
          </div>
          <i @click="showModal('update','education',graduation)" class="pi pi-pencil cursor-pointer absolute top-1 -right-2"></i>
        </div>
        <i @click="showModal('create','education')" class="pi pi-plus cursor-pointer absolute -top-2 right-3 text-lg"></i>
      </li> 
    </ul>
    <div v-else> 
      <p class="font-medium">{{ translate('no education', 'ucfirst') }}</p>
      <i @click="showModal('create','education')" class="pi pi-plus cursor-pointer absolute top-1 right-5 text-lg"></i>
    </div> 
  </Fieldset>

  <ModalDialogComponent :isvisible="visible" @close-modal="closeModalDialog">
    <template #title>
      {{ displayModalTitle }}
    </template>
    <template #content>
      <ProfessionalGraduationForm :graduation-to-update="graduationToUpdate" @close-modal="closeModalDialog" @education-updated="updateEducation" 
      :curriculum-id="props.educations.curriculum.id" />
    </template>
  </ModalDialogComponent>
        
  </div>
</template>

<script setup>
import { ref, onMounted, onUpdated } from 'vue'
import Fieldset from "primevue/fieldset";
import Skeleton from 'primevue/skeleton';
import requestHandler from "@/composables/requestHandler";
import { translate } from "@/composables/translate";
import useModalCurriculum from "@/composables/modalDialogCurriculum";
import ModalDialogComponent from "@/components/Utils/ModalDialogComponent.vue";
import ProfessionalGraduationForm from "@/components/Dashboard/Applicant/FormsCurriculum/ProfessionalGraduationForm.vue";
import { toUpperCase } from '@/composables/textUtils';

 const props = defineProps({
  educations: {
    type: Array,
    required: true,
    default: ()=> [],
  }
});

let graduations = ref([])
let isLoading = ref(false)
let visible = ref(false)  
let graduationToUpdate = ref(0)  
let { toggleCreateUpdateTitle, displayModalTitle } = useModalCurriculum()


async function updateEducation(){  

  isLoading.value = true
  const response = await requestHandler.executeRequest("/api/curriculum",{},"get");
  if (response.success) graduations.value = response.data.educations;
  
  isLoading.value = false
}

function showModal(type, title, graduation={}) {
  toggleCreateUpdateTitle(type,title)
  graduationToUpdate.value = graduation
  visible.value = true
}

function closeModalDialog(event){  
  visible.value = event
}

const dateFormated = ((date) => {
  return date.slice(0,10);
})

onUpdated(() => {
  isLoading.value = false
  if (props.educations.educations.length > 0 ) graduations.value = props.educations.educations
})

onMounted(() => {
  isLoading.value = true
});
</script>

<style scoped></style>